import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import { UserManualProvider } from '../contexts/userManual'
import InstallPage from '../pages/Install'
import InstallDevicePage from '../pages/InstallDevice'
import InstallHeaterPage from '../pages/InstallHeater'
import InstallRuuviTagPage from '../pages/InstallRuuviTag'
import LoadingState from '../components/LoadingState'
const InstallGeneratorPage = lazy(() => import('../pages/InstallGenerator'))

export default [
  {
    path: '/install',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.INSTALLER,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER
        ]}
      >
        <UserManualProvider pageId="43843606">
          <DashboardLayout>
            <InstallPage />
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/install/device',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.INSTALLER,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER
        ]}
      >
        <UserManualProvider pageId="43843606">
          <DashboardLayout>
            <InstallDevicePage />
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/install/device/project/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.INSTALLER,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER
        ]}
      >
        <UserManualProvider pageId="43843606">
          <DashboardLayout>
            <InstallDevicePage />
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/install/heater',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.INSTALLER,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER
        ]}
      >
        <DashboardLayout>
          <InstallHeaterPage />
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/install/ruuvi-tag',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.INSTALLER,
          UserRole.MANUFACTURER
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.RUUVI_TAGS}>
          <DashboardLayout>
            <InstallRuuviTagPage />
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/install/generator',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.INSTALLER,
          UserRole.MANUFACTURER
        ]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <InstallGeneratorPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
